import { defineComponent as _defineComponent } from 'vue'
import { PropType, ref, watch } from 'vue'
import { OpenMSOffice } from '../../types/FileManagerTypes'
import { useI18n } from 'vue-i18n-composable'
import { Icons } from '@/icons/icons'


export default /*#__PURE__*/_defineComponent({
  __name: 'OfficeContextMenuComponent',
  props: {
  configMode: {
    type: String as PropType<OpenMSOffice>,
    required: true
  }
},
  emits: ['saveConfig'],
  setup(__props, { emit }) {

const props = __props;

const { t } = useI18n()



// DEFINE PROPS  ======================================================================================================


const openMSOfficeConfigMode = ref<OpenMSOffice>(props.configMode)

// @note: revisar para quitar el watch
watch(
  () => props.configMode,
  (newValue) => {
    openMSOfficeConfigMode.value = newValue
  }
)

const msOfficeConfigurationContextMenuItems = [
  {
    text: t('components.file_manager.actions.config.local'),
    iconCss: Icons.CHECK
  },
  {
    text: t('components.file_manager.actions.config.wopi'),
    iconCss: Icons.CHECK
  }
]

// EVENTS =============================================================================================================
const onBeforeOpenMSOfficeConfigContextMenu = (args: any) => {
  if (openMSOfficeConfigMode.value === OpenMSOffice.WOPI) {
    args.items[0].iconCss = 'lf-icon-step-first'
    args.items[1].iconCss = 'lf-icon-radio-button-active'
  }
  if (openMSOfficeConfigMode.value === OpenMSOffice.LOCAL) {
    args.items[0].iconCss = 'lf-icon-radio-button-active'
    args.items[1].iconCss = 'lf-icon-step-first'
  }
}

const onOpenMSOfficeConfigClick = (args: any) => {
  let newMode: OpenMSOffice
  switch (args.item.text) {
    case t('components.file_manager.actions.config.local'):
      newMode = OpenMSOffice.LOCAL
      break
    case t('components.file_manager.actions.config.wopi'):
      newMode = OpenMSOffice.WOPI
      break
    default:
      newMode = openMSOfficeConfigMode.value
      break
  }

  openMSOfficeConfigMode.value = newMode
  emit('saveConfig', newMode)
}

return { __sfc: true,t, emit, props, openMSOfficeConfigMode, msOfficeConfigurationContextMenuItems, onBeforeOpenMSOfficeConfigContextMenu, onOpenMSOfficeConfigClick }
}

})